import { LucideIcon } from "lucide-react";
import { IconType as FaIconType } from "react-icons";

export type PropertyStatusIconType = LucideIcon | FaIconType;

export const PropertyStatus = ({
  color,
  IconType,
  title,
  description,
}: {
  color: string;
  IconType: PropertyStatusIconType;
  title: string;
  description: string;
}) => {
  return (
    <div className="flex flex-row items-center gap-2 text-xs font-normal bg-white pr-2 rounded-br-sm rounded-bl-sm h-[28px]">
      <div
        className="flex flex-row h-full px-2 items-center gap-2 rounded-tl-sm text-white"
        style={{ backgroundColor: color }}
      >
        <IconType className="h-[12px] w-[12px]" />
        <span className="font-bold">{title}</span>
      </div>
      <span className="font-normal text-gray-500">{description}</span>
    </div>
  );
};
